<template>
  <v-card>
    <v-card-title style="border-bottom: 1px solid #efefef">
      <div class="d-flex flex-row align-center justify-space-between">
        <span class="text-h6">{{ item.title }}</span>

        <router-link :to="{ name: 'ManagerAccount' }">
          <v-icon
            class="fs-22 c-grey va-sub"
            icon="edit"
          />
        </router-link>
      </div>
    </v-card-title>

    <v-card-text>
      <div
        v-for="(data, idx) in item.items"
        :key="idx"
        class="d-flex align-center flex-row py-4 px-2"
      >
        <div class="d-flex flex-column me-3 max-w-100">
          <v-img
            v-if="data.image"
            :src="data.image"
            alt=""
            height="56"
            width="56"
            cover
          />
          <v-icon
            v-else
            :icon="data.icon || 'person'"
            :size="56"
            color="primary"
          />
        </div>

        <div class="flex-1">
          <p class="text-subtitle-2">
            {{ data.main }}
          </p>
          <p class="text-body-1">
            {{ data.sub }}
          </p>
          <p
            v-for="(details, i) in data.details"
            :key="i"
            class="text-body-1"
          >
            <span
              v-for="(detail, n) in details"
              :key="n"
              class="disc"
              >{{ detail }}</span
            >
          </p>
        </div>

        <v-divider
          v-if="idx < item.items.length - 1"
          :thickness="1"
          style="border-color: #efefef"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
defineProps({
  item: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.disc:not(:first-of-type) {
  margin-left: 5px;
  padding-left: 15px;
  position: relative;
}
.disc:not(:first-of-type):before {
  content: '•';
  left: 0;
  position: absolute;
}
</style>
